import { User } from "./user.model";

export class registerOnlyUserDTOs{
    
registerOnlyUserDTOs: User[];
}